import { authFetch, AuthExpiredError } from '../utils/apiClient'
const API_GATEWAY_URL = process.env.REACT_APP_API_GATEWAY_URL
//--------------------------UTILS-------------------------------------------------

// Get authentication token from localStorage
export function getAuthToken() {
  return localStorage.getItem('token')
}

function isEmptyArray(arr) {
  if (Array.isArray(arr) && !arr.length) {
    return true
  }
  return false
}

function isEmptyObject(obj) {
  if (isEmptyArray(Object.keys(obj))) {
    return true
  }
  return false
}

function createCategoryParam(categories) {
  //console.log('createCategoryparams:', categories)
  return categories
    .map(category => {
      return `cat=${category.id}&`
    })
    .join('')
}

function createNewUrl(url, params) {
  let gUrl = new URL(url)
  if (!isEmptyObject(params)) {
    Object.keys(params).map(key => {
      if (Array.isArray(params[key])) {
        params[key].map(pkey => {
          gUrl.searchParams.append(key, pkey)
          return true
        })
      } else {
        gUrl.searchParams.append(key, params[key])
      }
      return true
    })
  }
  return gUrl.toString()
}

//--------------------------GET REQUEST-------------------------------------------------

async function getRequest({ url, params = {} }) {
  try {
    const token = localStorage.getItem('token')
    if (!token) {
      throw new Error('Authentication token not available')
    }
    let response
    url = createNewUrl(url, params)

    response = await authFetch(url, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: 'application/json'
      }
    })

    if (!response.ok) {
      const errorText = await response.text()
      throw new Error(`HTTP ${response.status}: ${errorText}`)
    }
    const responseText = await response.text()
    try {
      return JSON.parse(responseText)
    } catch (parseError) {
      throw new Error(
        `Invalid JSON response: ${responseText.substring(0, 100)}...`
      )
    }
  } catch (error) {
    console.error('Request error:', error)
    if (error instanceof AuthExpiredError) {
      throw error
    }
    throw error
  }
}

//--------------------------POST REQUEST-------------------------------------------------

async function postRequest(url, params = {}, payload) {
  let response
  try {
    const token = localStorage.getItem('token')
    if (!token) {
      throw new Error('Authentication token not available')
    }
    url = createNewUrl(url, params)
    //console.log('PostRequest URL: ', url)
    const fetchResponse = await authFetch(url, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    })

    if (!fetchResponse.ok) {
      const errorText = await fetchResponse.text()
      throw new Error(`HTTP ${fetchResponse.status}: ${errorText}`)
    }

    response = await fetchResponse.json()
  } catch (error) {
    console.error('PostRequest error:', error)
    if (error instanceof AuthExpiredError) {
      throw error
    }
    throw error
  }
  return response
}

//--------------------------PUT REQUEST-------------------------------------------------

async function putRequest(url, params = {}, payload) {
  let response
  try {
    const token = localStorage.getItem('token')
    if (!token) {
      throw new Error('Authentication token not available')
    }
    url = createNewUrl(url, params)
    //console.log('PutRequest URL: ', url)
    const fetchResponse = await authFetch(url, {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    })

    // Check if the response is successful
    if (!fetchResponse.ok) {
      const errorText = await fetchResponse.text()
      throw new Error(`HTTP ${fetchResponse.status}: ${errorText}`)
    }

    response = await fetchResponse.json()
  } catch (error) {
    console.error('PutRequest error:', error)
    if (error instanceof AuthExpiredError) {
      throw error
    }
    throw error
  }
  return response
}

//--------------------------DELETE REQUEST-------------------------------------------------

async function deleteRequest(url, params = {}) {
  try {
    const token = localStorage.getItem('token')
    if (!token) {
      throw new Error('Authentication token not available')
    }
    url = createNewUrl(url, params)
    let fetchResponse = await authFetch(url, {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: 'application/json',
        'Content-Type': 'application/json'
      }
    })

    // Check if the response is successful
    if (!fetchResponse.ok) {
      const errorText = await fetchResponse.text()
      throw new Error(`HTTP ${fetchResponse.status}: ${errorText}`)
    }

    const response = await fetchResponse.json()
    console.log('deleteRequest response:', response)
    return response
  } catch (error) {
    console.error('There was an error with the delete request:', error)
    if (error instanceof AuthExpiredError) {
      throw error
    }
    throw error
  }
}

//--------------------------REQUESTS-------------------------------------------------

export function getSearchedAssets(userId, searchTerm) {
  if (!userId) {
    throw new Error('Cannot execute query - missing user ID')
  }
  let url = `${API_GATEWAY_URL}/k1/users/${userId}/assets?search=${searchTerm}`
  let response = getRequest({ url })
  return response
}

export function getUser(userId) {
  let url = `${API_GATEWAY_URL}/k1/users/${userId}`
  let response = getRequest({ url })
  return response
}

export function updateUser(userId, userData) {
  let url = `${API_GATEWAY_URL}/k1/users/${userId}`
  return putRequest(url, {}, userData)
}

export function getRequestAssets(config) {
  const { userId, categories = [], pageLimit, currentPage } = config
  if (!userId) {
    throw new Error('Cannot execute query - missing user ID')
  }
  const categoriesParam = createCategoryParam(categories)

  const t = (config.type || '').toLowerCase()
  const typeParam = t && t !== 'image' ? `type=${encodeURIComponent(t)}&` : ''

  const url =
    `${API_GATEWAY_URL}/k1/users/${userId}/assets?` +
    categoriesParam +
    typeParam +
    `page=${currentPage.current}&limit=${pageLimit}`

  try {
    const response = getRequest({ url })
    return response
  } catch (error) {
    console.error('Error fetching assets:', error)
    throw error
  }
}

export function fetchDuplicates() {
  let url = `${API_GATEWAY_URL}/k1/categories/system/duplicate`
  let response = getRequest({ url })
  return response
}

export function fetchFavorites() {
  let url = `${API_GATEWAY_URL}/k1/categories/system/favorite`
  let response = getRequest({ url })
  return response
}

export async function fetchAssetsByCategory({ categoryId, userId }) {
  let url = `${API_GATEWAY_URL}/k1/users/${userId}/assets?cat=${categoryId}`
  try {
    let response = await getRequest({ url })
    return response
  } catch (error) {
    console.error(`Error fetching assets for category ${categoryId}:`, error)
    throw error
  }
}

export async function fetchUncategorizedAssets({ userId, assetType }) {
  if (!userId) {
    throw new Error('Cannot execute query - missing user ID')
  }
  let url = `${API_GATEWAY_URL}/k1/assets`
  let params = {
    cat: 'none'
  }
  if (assetType) {
    params.type=assetType
  }
  try {
    let response = await getRequest({ url, params })
    if (response && response.assets) {
      console.log('Uncategorized assets:', response.assets)
    }
    return response
  } catch (error) {
    console.error('Error fetching uncategorized assets:', error)
    throw error
  }
}

export function postFavorites(config) {
  const userId = config?.userId
  if (!userId) {
    throw new Error('Cannot execute query - missing user ID')
  }
  let url = `${API_GATEWAY_URL}/k1/users/${userId}/categorizeassets`
  let payload = config.payload
  return postRequest(url, {}, payload)
}

export function deleteAsset(config) {
  const userId = config?.userId
  if (!userId) {
    throw new Error('Cannot execute query - missing user ID')
  }
  let url = `${API_GATEWAY_URL}/k1/users/${userId}/assets/${config?.assetId}`
  let payload = config.payload
  return deleteRequest(url, {}, payload)
}

//userId, keysForSigning
export function postRequestSignedUrls(config) {
  let userId = config?.userId
  if (!userId) {
    throw new Error('Cannot execute query - missing user ID')
  }
  let url = `${API_GATEWAY_URL}/k1/users/${userId}/signurls`
  let payload = config?.payload
  return postRequest(url, {}, payload)
}

export function postRequestCustomerPortalSession(config) {
  let url = `${API_GATEWAY_URL}/k1/subscription/billing/session`
  let payload = config?.payload
  return postRequest(url, {}, payload)
}

export function getRequestUserCategories(config) {
  const userId = config?.userId
  if (!userId) {
    throw new Error('Cannot execute query - missing user ID')
  }

  let url = `${API_GATEWAY_URL}/k1/users/${userId}/topcategories`

  let params = {}
  if (config.assetType) {
    params['assettype'] = config.assetType
  }

  return getRequest({ url, params })
}

export function getRequestAssetsByQuery(config) {
  const userId = config?.userId
  if (!userId) {
    throw new Error('Cannot execute query - missing user ID')
  }
  let url = `${API_GATEWAY_URL}/k1/users/${userId}/assets`
  let params = config?.params
  return getRequest({ url, params: params })
}

export function updateCategoryName({ userId, categoryId, name }) {
  if (!userId) {
    throw new Error('Cannot execute query - missing user ID')
  }
  let url = `${API_GATEWAY_URL}/k1/users/${userId}/categories/${categoryId}`
  return putRequest(url, {}, { name })
}

export function deleteCategory({ userId, categoryId }) {
  if (!userId) {
    throw new Error('Cannot execute query - missing user ID')
  }
  let url = `${API_GATEWAY_URL}/k1/users/${userId}/categories/${categoryId}`
  return deleteRequest(url)
}

export function restoreCategory({ userId, categoryId }) {
  if (!userId) {
    throw new Error('Cannot execute query - missing user ID')
  }
  let url = `${API_GATEWAY_URL}/k1/users/${userId}/categories/${categoryId}?restore=true`
  return deleteRequest(url)
}

export async function restoreAsset({ userId, assetId }) {
  if (!userId) {
    throw new Error('Cannot execute query - missing user ID')
  }
  const token = localStorage.getItem('token')
  if (!token) {
    throw new Error('Authentication token not available')
  }
  const url = `${API_GATEWAY_URL}/k1/users/${userId}/assets/${assetId}?restore=true`
  const fetchResponse = await authFetch(url, {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: 'application/json',
      'Content-Type': 'application/json'
    }
  })
  if (!fetchResponse.ok) {
    const errorText = await fetchResponse.text()
    throw new Error(`HTTP ${fetchResponse.status}: ${errorText}`)
  }
  const text = await fetchResponse.text()
  return text ? JSON.parse(text) : {}
}

export function updateAssetName({ userId, assetId, name }) {
  if (!userId) {
    throw new Error('Cannot execute query - missing user ID')
  }
  let url = `${API_GATEWAY_URL}/k1/users/${userId}/assets/${assetId}`
  return putRequest(url, {}, { id: assetId, origFilename: name })
}

export function removeFavorite(config) {
  const userId = config?.userId
  if (!userId) {
    throw new Error('Cannot execute query - missing user ID')
  }
  let url = `${API_GATEWAY_URL}/k1/users/${userId}/uncategorizeassets`
  let payload = config.payload
  return postRequest(url, {}, payload)
}

export async function fetchDeletedAssets({ userId }) {
  if (!userId) {
    throw new Error('Cannot execute query - missing user ID')
  }
  let url = `${API_GATEWAY_URL}/k1/users/${userId}/assets`
  let params = { deleted: true }
  try {
    let response = await getRequest({ url, params })
    return response
  } catch (error) {
    console.error('Error fetching deleted assets:', error)
    throw error
  }
}

export function destroyAsset({ userId, assetId }) {
  if (!userId) {
    throw new Error('Cannot execute query - missing user ID')
  }
  let url = `${API_GATEWAY_URL}/k1/users/${userId}/assets/${assetId}?destroy=true`
  return deleteRequest(url)
}

export async function fetchDocuments({ userId }) {
  if (!userId) {
    throw new Error('Cannot execute query - missing user ID')
  }
  let url = `${API_GATEWAY_URL}/k1/users/${userId}/assets?type=document`
  try {
    let response = await getRequest({ url })
    return response
  } catch (error) {
    console.error('Error fetching documents:', error)
    throw error
  }
}
